import { ApplicationData } from "../ApplicationData";

export class DateControl {
  constructor(options) {
    this.id = options.id;
  }
  render(datePickerOptions) {
    var dateFormat = ApplicationData.language.dateFormat.replace("yyyy", "yy");

    $("#" + this.id)
      .datepicker(datePickerOptions)
      .datepicker("option", "dateFormat", dateFormat);
  }
  onChange(callback, rootSelector) {
    if (rootSelector === undefined) {
      rootSelector = $("body");
    }
    rootSelector.on("change", "#" + this.id, function (event) {
      if (callback) {
        callback(event.currentTarget, event);
      }
    });
  }
  disable() {
    $("#" + this.id)
      .attr("disabled", "disabled")
      .addClass("disabled");
  }
  enable() {
    $("#" + this.id)
      .prop("disabled", false)
      .removeClass("disabled");
  }
  setDefaultSelection() {}
  getCurrentSelection() {
    // Will now return a date object
    return $("#" + this.id).datepicker("getDate");
  }
  setCurrentSelection(value) {
    $("#" + this.id).val(value);
  }
  setCurrentDate() {
    $("#" + this.id).val(
      new Date().format(ApplicationData.language.dateFormat)
    );
  }
  setFutureDate(months) {
    $("#" + this.id).val(
      new Date().AddMonth(months).format(ApplicationData.language.dateFormat)
    );
  }
  setPreviousDate(months) {
    $("#" + this.id).val(
      new Date()
        .SubtractMonth(months)
        .format(ApplicationData.language.dateFormat)
    );
  }
  addEvents() {}
}
